



















import Vue from "vue";

export default Vue.extend({
  name: "AudioPlaybackButton",
  props: {
    disabled: {
      type: Boolean,
      default: false
    },
    icon: {
      type: String,
      required: true
    },
    currentProgress: {
      type: Number,
      required: true
    }
  },
  watch: {
    currentProgress(newValue) {
      const percent = newValue || 0;

      const circle: any = this.$refs.circle;
      if (!circle.r) {
        return;
      }
      const radius = circle.r.baseVal.value;
      const circumference = radius * 2 * Math.PI;
      circle.style.strokeDasharray = `${circumference} ${circumference}`;
      circle.style.strokeDashoffset = `${circumference}`;
      circle.style.strokeDashoffset = circumference - (percent / 100) * circumference;

      if (percent >= 100) {
        (this.$refs.icon as HTMLElement).classList.remove("playing");
      }
    }
  }
});
